/**
 * Converts a CSS color string to an [r, g, b] array (0-255 each).
 * Handles #RGB, #RRGGBB, rgb(...), and rgba(...) forms.
 * Falls back to [128, 128, 128] for unrecognised input.
 */
export function hexToRgb(hex) {
  if (!hex || typeof hex !== 'string') return [128, 128, 128]

  // Handle rgb(...) and rgba(...) — e.g. MUI getContrastText returns rgba(0,0,0,0.87)
  const rgbMatch = hex.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/)
  if (rgbMatch) {
    return [parseInt(rgbMatch[1], 10), parseInt(rgbMatch[2], 10), parseInt(rgbMatch[3], 10)]
  }

  let clean = hex.replace('#', '')
  if (clean.length === 3) {
    clean = clean
      .split('')
      .map(c => c + c)
      .join('')
  }
  if (clean.length !== 6) return [128, 128, 128]

  const n = parseInt(clean, 16)
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255]
}

/**
 * Returns a CSS rgba() string from a hex color and an alpha (0–1).
 */
export function hexToRgba(hex, alpha = 1) {
  const [r, g, b] = hexToRgb(hex)
  return `rgba(${r},${g},${b},${alpha})`
}

/**
 * Loads an image from a URL, returns a Promise<HTMLImageElement>.
 */
export function loadImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = reject
    img.src = url
  })
}
